import { FunctionComponent, useEffect, useState } from 'react'
import { getWorkroomPostComments } from 'Frontend/scripts/services/workrooms.service'
import { IWorkroomComment } from 'Frontend/scripts/models/workrooms.model'
import WorkroomPostComment from './WorkroomPostComment'
import CreateWorkroomPostComment from './CreateWorkroomPostComment'

interface WorkroomPostCommentsProps {
  workroomId: number
  postId: number
  permissionToCreateCommentOnPost: boolean
  callback: () => void
}

const WorkroomPostComments: FunctionComponent<WorkroomPostCommentsProps> = ({
  workroomId,
  postId,
  permissionToCreateCommentOnPost,
}) => {
  const [comments, setComments] = useState<IWorkroomComment[]>([])
  const [commentsHasChanged, setCommentsHasChanged] = useState<boolean>(false)

  useEffect(() => {
    getWorkroomPostComments(workroomId, postId).then((commentsData) => {
      setComments(commentsData)
    })
  }, [commentsHasChanged])

  return (
    <>
      {comments.map((comment: IWorkroomComment) => (
        <WorkroomPostComment
          key={`post-comment-${comment.id}`}
          workroomId={workroomId}
          postId={postId}
          comment={comment}
          callback={() => setCommentsHasChanged(!commentsHasChanged)}
        />
      ))}

      {permissionToCreateCommentOnPost && (
        <CreateWorkroomPostComment
          workroomId={workroomId}
          postId={postId}
          callback={() => setCommentsHasChanged(!commentsHasChanged)}
        />
      )}
    </>
  )
}

export default WorkroomPostComments
